// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F1WiJ","item":"styles_item__RPsQN"};